<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="806" height="283" viewBox="0 0 806 283" fill="none" style="margin: 0 auto">

    <g clip-path="url(#clip0_992_3674)">
      <rect width="806" height="283" fill="white"/>
      <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12" font-weight="500" letter-spacing="0.01em"><tspan x="341.975" y="253.28">Очно-заочная форма
</tspan></text>
      <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12" font-weight="500" letter-spacing="0.01em"><tspan x="587.975" y="253.28">Очно-заочная форма
</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan xmlns="http://www.w3.org/2000/svg" x="300.37" y="232.22">Оптимизация структуры приема<title>Корректировка общего объема КЦП по УГСН (НПС) по заочной (очно-заочной) форме обучения в связи с оптимизацией структуры приема и (или) изменением ФГОС.</title></tspan></text>

      <text xmlns="http://www.w3.org/2000/svg" fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12" font-weight="bold" letter-spacing="0em">
	<tspan x="510" y="227" data-tooltip="Корректировка общего объема КЦП по УГСН (НПС) по заочной (очно-заочной) форме обучения в связи с оптимизацией структуры приема и (или) изменением ФГОС.">?</tspan>
</text>


      <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="557.167" y="232.22">Прогнозируемый объем КЦП</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="404" y="200.18">{{
          (!Number.isNaN(getPaData.brf2) && (!(getPaData.brf2 >= 0))) ? '(' : ''
        }}{{ getPaData.brf2 }}{{
          (!Number.isNaN(getPaData.brf2) && (!(getPaData.brf2 >= 0))) ? ')' : ''
        }}</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47" font-weight="bold" letter-spacing="0.01em"><tspan x="650" y="200.18">{{ getPaData.kcp2 }}</tspan></text>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581" letter-spacing="0.01em"><tspan x="268" y="195.765">+</tspan></text>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581" letter-spacing="0.01em"><tspan x="514" y="195.765">=</tspan></text>
      <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12" font-weight="500" letter-spacing="0.01em"><tspan x="91.9752" y="253.28">Очно-заочная форма
</tspan></text>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="29" y="232.22">Объем КЦП на предшествующий год</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="154" y="200.18">{{ getPaData.kcpTrf2 }}</tspan></text>
      <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" letter-spacing="0.01em"><tspan x="29" y="133.04">Очно-заочная форма
</tspan></text>
      <line x1="30" y1="100.5" x2="775" y2="100.5" stroke="#CFD8DC"/>
      <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" letter-spacing="0.01em"><tspan x="30" y="77.24">{{
          getPaData.sprKcpGroupSprUslName
        }}: {{ getPaData.sprKcpGroupId }} {{ getPaData.sprKcpGroupName }}</tspan></text>
      <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22" letter-spacing="0.01em"><tspan x="30" y="43.68">Прогнозирование общего объема КЦП в целом по УГСН (НПС)
</tspan></text>
    </g>
    <defs>
      <clipPath id="clip0_992_3674">
        <rect width="806" height="283" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "Pa2",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getPaData: {
        "id": 0,
        "sprKcpGroupId": "string",
        "sprKcpGroupName": "string",
        "sprKcpGroupSprUslName": "string",
        "sprRegionId": "string",
        "sprRegionName": "string",
        "sprRegionNameGenitive": "string",
        "drf": 0,
        "pbMrf": 0,
        "kcPrf23": 0,
        "pbMrf1": 0,
        "limPbMrf1": 0,
        "kcpTrf1": 0,
        "minPbMrf1": 0,
        "maxPbMrf1": 0,
        "brf1": 0,
        "opPrf1": 0,
        "korRf1": 0,
        "kcp1": 0,
        "kcpTrf2": 0,
        "brf2": 0,
        "kcp2": 0,
        "kcpTrf3": 0,
        "brf3": 0,
        "kcp3": 0,
        "pprf": 0,
        "okcpRf1": 0,
        "dkcpRf1": 0
      },
    }
  },
  async created() {
    await this.getPaSvg();
  },
  methods: {
    async getPaSvg() {
      try {
        const res = await request({
          endpoint: `/api/information/getPa?kcpGroupId=${this.kcpGroupId}`,
          method: 'get',
        });
        if (res.status === 200 ) {
          console.log('getPaSvg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }else
            this.mapServerData();
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>